// extracted by mini-css-extract-plugin
module.exports = {"searchContainer":"SearchItem_searchContainer__2Rl7f","active":"SearchItem_active__3UbHg"};